import { render, staticRenderFns } from "./RightPositioned.vue?vue&type=template&id=6705c7f8&"
import script from "./RightPositioned.vue?vue&type=script&lang=js&"
export * from "./RightPositioned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports